var map = {
	"./legal/pages/review": [
		41924,
		[
			4171,
			894,
			9300,
			5319,
			2482,
			5443,
			6671,
			5702,
			7441,
			2954,
			804,
			8549,
			1192,
			5952,
			8835,
			2121,
			3032,
			8914,
			4755,
			9149,
			7047,
			2479,
			200
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5488;
module.exports = webpackAsyncContext;